import { gql } from "graphql-tag"

const homeVideoReviews = gql`
  type Query {
    drafts: [HomeVideoReview]
    draftsWave(cursor: String): HomeVideoReviewWave

    getHomeVideoReviews(isUHD: Boolean, limit: Int): [HomeVideoReview]
    getHomeVideoReviewsWave(cursor: String): HomeVideoReviewWave
    getHomeVideoReview(id: ID!): HomeVideoReview
    searchHomeVideoReviews(
      searchHomeVideoReviewsInput: SearchHomeVideoReviewsInput!
    ): [HomeVideoReview]
  }
`

export default homeVideoReviews
